import {
    COMPRAS_LIST,
    COMPRAS_FULLLIST,
    COMPRAS_LISTA,
    COMPRAS_FILTER,
    COMPRAS_CREATE,
    COMPRAS_CREATE_FORM,
    COMPRAS_UPDATE,
    COMPRAS_UPDATE_SUCCESS,
    COMPRAS_CREATE_SUCCESS,
    COMPRAS_CREATE_FORM_SUCCESS,
    COMPRAS_LIST_SUCCESS,
    COMPRAS_FULLLIST_SUCCESS,
    COMPRAS_REQUEST_FAILED,
    COMPRAS_READ,
    COMPRAS_READ_SUCCESS,

  } from "./actionTypes";
  
  export const comprasList = () => {
    return {
      type: COMPRAS_LIST,
      payload: {},
    };
  };
  export const comprasFullList = () => {
    return {
      type: COMPRAS_FULLLIST,
      payload: {},
    };
  };
  export const comprasLista = () => {
    return {
      type: COMPRAS_LISTA,
      payload: {},
    };
  };
  
  export const comprasCreate = (compras) => {
    return {
      type: COMPRAS_CREATE,
      payload: compras,
    };
  };
  export const comprasCreateformData = (compras) => {
    return {
      type: COMPRAS_CREATE_FORM,
      payload: compras,
    };
  };
  
  export const comprasFilter = (changeUrl) => {
    return {
      type: COMPRAS_FILTER,
      payload: { changeUrl },
    };
  };
  
  export const CasosRead = (id) => {
    return {
      type: COMPRAS_READ,
      payload: {id},
    };
  };

  export const CasosReadSuccess = (data) => {
    return {
      type: COMPRAS_READ_SUCCESS,
      payload: data,
    };
  };
  
  export const comprasUpdate = (id, data) => {
    return {
      type: COMPRAS_UPDATE,
      payload: { id, data },
    };
  };
  
  export const comprasListSuccess = (compras) => {
    return {
      type: COMPRAS_LIST_SUCCESS,
      payload: compras,
    };
  };
  export const comprasFullListSuccess = (compras) => {
    return {
      type: COMPRAS_FULLLIST_SUCCESS,
      payload: compras,
    };
  };
  
  export const comprasCreateSuccess = (comprasCreated) => {
    return {
      type: COMPRAS_CREATE_SUCCESS,
      payload: comprasCreated,
    };
  };
  export const comprasCreateFormSuccess = (comprasCreated) => {
    return {
      type: COMPRAS_CREATE_FORM_SUCCESS,
      payload: comprasCreated,
    };
  };
  
  export const comprasUpdateSuccess = (compras) => {
    return {
      type: COMPRAS_UPDATE_SUCCESS,
      payload: compras,
    };
  };
  
  export const comprasRequestFailed = (error) => {
    return {
      type: COMPRAS_REQUEST_FAILED,
      payload: error,
    };
  };
  